<script>
  import { createEventDispatcher } from "svelte";
  import Spinner from "svelte-spinner";

  export let background = "var(--background-color)";
  export let border = "var(--secondary-color)";
  export let color = "var(--secondary-color)";
  export let disabled = false;
  export let margin = 0;
  export let padding = ".75em 1.5em";
  export let size = "1.6rem";
  export let working = false;

  const dispatch = createEventDispatcher();

  /**
   * Dispatch click event
   *
   * @param {Event} event Original event
   */
  function click(event) {
    dispatch("click", event);
  }
</script>

<style>
  button {
    --background: var(--background, var(--background-color));
    --border: var(--border, var(--secondary-color));
    --color: var(--color, var(--secondary-color));
    --margin: var(--margin, 0);
    --padding: var(--padding, .75em 1.5em);
    --size: var(--size, 1.75rem);
    align-items: center;
    appearance: none;
    background: var(--background);
    border: 2px solid var(--border);
    border-radius: .25em;
    box-sizing: border-box;
    color: var(--color);
    cursor: pointer;
    display: flex;
    font-size: var(--size);
    font-weight: bold;
    margin: var(--margin);
    padding: var(--padding);
  }

  button:active,
  button[disabled] {
    opacity: 0.75;
  }

  .spinner {
    margin-left: 0.5rem;
  }
</style>

<button type="button" on:click|preventDefault|stopPropagation={click} disabled={disabled || working} style="--background: {background}; --border: {border}; --color: {color}; --margin: {margin}; --padding: {padding}; --size: {size}">
  <slot />

  {#if working}
    <span class="spinner"><Spinner size="20" color="var(--on-secondary-color)" /></span>
  {/if}
</button>
